declare type PathTransfer = 'Smart' | 'Skysales';
declare type PathHelper = 'encryptams';
export interface TransferDataRequest {
  recordLocator: string;
  type: PathTransfer;
  email: string;
  cultureCode: string;
}

export interface ResponseDataTransfer {
  data: string;
}

export interface SmartTransferResult {
  cryptData: string;
  culture: string;
}

export const typeTransfer: Record<PathTransfer, PathTransfer> = {
  Smart: 'Smart',
  Skysales: 'Skysales'
};

export const HelpersDataTransfer: Record<PathHelper, PathHelper> = {
  encryptams: 'encryptams'
};
